
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getApprovalstatus = async () => {
  return await get<ApiResponse<any[]>>("/approvalstatus").then((res)=>{
      return res
    })
};

 